// LocalStorage
import { useLocalStorageContext } from '@/LocalStorage';

// Utilities
import { getUserInfo, DEFAULT_USER_INFO } from '@/API/Client/Utilities';

// Spec
import { Mutation } from '@/API/Client/Types/graphql';

type Authorization = Mutation['Activate' | 'SignIn'];

const COOKIE = 'Authorization';

const useUserInfo = () => {
  const { getItem } = useLocalStorageContext();

  const Authorization: Authorization = getItem(COOKIE);

  const UserInfo = getUserInfo(Authorization);

  return UserInfo;
};

export { getUserInfo, DEFAULT_USER_INFO };
export default useUserInfo;
